import { faCalendar, faClock, faHashtag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate, isDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

type AppointmentDetailsProps = {
  appointment: Appointment;
};

export const AppointmentDetails = ({ appointment }: AppointmentDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="kiosk-comm-section-container">
      <div className="kiosk-comm-section-header">{t("v8_appointment_information", "Appointment Information")}</div>

      <Grid>
        <Grid.Row>
          <Grid.Column width={4}>
            <span className="appointment-information icon-text">WO </span>
            <FontAwesomeIcon icon={faHashtag} className="i-green mr-5" />
            <span>{appointment.wo_nr}</span>
          </Grid.Column>
          <Grid.Column width={4}>
            <span className="icon-text">{t("v8_reg", "Reg")}. </span>
            <FontAwesomeIcon icon={faHashtag} className="i-green mr-5" />
            <span>{appointment.reg_number}</span>
          </Grid.Column>
          {appointment.due_in && (isDate(appointment.due_in) || !appointment.due_in.startsWith("0001-01-01T00:00:00")) ? (
            <>
              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faCalendar} className="i-green mr-5" />
                {formatDate(appointment.due_in, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>

              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faClock} className="i-green mr-5" />
                {formatDate(appointment.due_in, DATE_FORMATS_FNS.hoursMinutes)}
              </Grid.Column>
            </>
          ) : (
            appointment.time_car_app &&
            (isDate(appointment.time_car_app) || !appointment.time_car_app.startsWith("0001-01-01T00:00:00")) && (
              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faCalendar} className="i-green mr-5" />
                {formatDate(appointment.time_car_app, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>
            )
          )}
        </Grid.Row>
      </Grid>
    </div>
  );
};
